



































import { Tag } from "@api/models/Tag";
import SelectControl from "@share/common/controls/select/SelectControl.vue";
import { DropDownItem } from "@share/common/drop-down/types";
import TagList from "@share/common/tag-list/TagList.vue";
import TagItem from "@share/common/tag/TagItem.vue";
import { Component, Prop, Mixins } from "vue-property-decorator";
import { BaseBorderless } from "@share/common/form/form-controls/base/borderless/base-borderless";
import { StubInputBase } from "@share/common/form/form-controls/stub/stub-input-base";

@Component({
    components: { SelectControl, TagList, TagItem }
})

export default class TagSelect extends Mixins(StubInputBase, BaseBorderless) {

    @Prop({ default: [] }) declare value: DropDownItem[];
    @Prop({ default: (() => [])}) source: DropDownItem[];

    keyword = "";

    search(keyword: string) {
        this.keyword = keyword;
        this.$emit('search', keyword)
    }

    remove(event: PointerEvent, id?: string) {
        event.stopImmediatePropagation();

        const newValue = this.value.filter((item) => item.id !== id)

        this.$emit('input', newValue);
    }

    get tags(): { tag: Readonly<Tag>; isSelected: boolean }[] {
        return this.value.map((item) => ({ tag: item as Tag, isSelected: false }))
    }
}

